
/**
 * 各種設定用ファイル
 */

// 実行環境 開発（Chrome）：DEV、 検証(xcode,android studio)：TST、 本番：PRD
export const env = "PRD";
// サーブレットURL
export const serverUrl: {[key:string]: string} = 
{
  'DEV':'https://localhost:8443/MO',
  'TST':'https://192.168.1.66:8443/MO',
  'PRD':'https://kinitta.com/MO',
};

export const serverUrl2: {[key:string]: string} = 
{
  'DEV':'https://localhost:8081',
  // 'TST'の場合は、URLを下のコマンで取得したhttpの参照先に変更する
  // ngrok http 8081
  // 'TST':'https://634f-240d-1a-a22-1f00-bcab-b9a4-8f30-41a3.ngrok-free.app', // スマフォでテストする際はこのURLを変更する
  'TST':'https://192.168.1.66:8081',
  'PRD':'https://kinitta.com/MO14',
};

// デバッグフラグ
export const debugFlag: {[key:string]: boolean} = {'DEV':true,'TST':true,'PRD':false};